<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'AboutMeCard',
  props: {
    name: {
      type: String,
      required: true
    },
    data: {
      type: Object as any,
      required: true
    }
  },
  setup(props) {
    return {
      data: props.data
    }
  },
  methods: {
    formatUrl(url: string) {
      if (url.startsWith('mailto')) {
        return url
      } else {
        return '////' + url
      }
    }
  }
})
</script>

<template>
  <v-card-text>
    <div class="d-flex flex-column">
      <v-img
        :src="'/api/Content/' + data.imageUrl"
        class="mx-auto"
        height="150"
        width="150"
        style="
          border-radius: 50%;
          border: 5px solid var(--color-cu-gold);
          background-color: var(--color-cu-dark-gray);
        "
      ></v-img>
      <h2 class="name text-center">{{ name }}</h2>
      <span class="title text-center">{{ data.title }}</span>
      <span class="pronouns text-center">{{ data.pronouns }}</span>
    </div>
  </v-card-text>
  <v-divider v-if="data.headers.length > 0" :thickness="4"></v-divider>
  <v-card-text v-if="data.headers.length > 0">
    <div style="text-align: center; font-size: 1.2em">I can help with...</div>
    <div class="d-flex flex-row justify-space-evenly flex-wrap">
      <div v-for="(item, index) in data.headers" :key="index" class="d-flex flex-column pr-4 pl-4">
        <div class="skills-header">{{ data.headers[index] }}</div>
        <div class="skills-item" v-for="item in data.items[index].split(',')">
          {{ item }}
        </div>
      </div>
    </div>
  </v-card-text>
  <v-divider v-if="data.links.length > 0" :thickness="4"></v-divider>
  <v-card-text class="d-flex justify-space-around flex-wrap">
    <template v-for="(item, index) in data.links" :key="index">
      <v-btn
        class="ma-2"
        min-width="100px"
        color="blue"
        :href="formatUrl(data.links[index])"
        target="_blank"
        >{{ data.linkTexts[index] }}</v-btn
      >
    </template>
  </v-card-text>
</template>

<style scoped>
.name {
  color: var(--color-cu-gold);
  font-size: 1.8em;
  margin-top: 10px;
}
.title {
  color: white;
  font-size: 1.2em;
  font-weight: 600;
}
.pronouns {
  color: white;
  font-size: 1em;
}
.skills-header {
  color: var(--color-cu-gold);
  font-size: 1.5em;
  margin-top: 10px;
  font-weight: 900;
  text-align: center;
}
.skills-item {
  color: white;
  font-size: 1em;
  margin-top: -2px;
  text-align: center;
}
</style>
